import React, {useState, useEffect, useRef} from 'react';

import * as S from './OfferTag.styles';

import GocashOfferIcon from '../../../../../Icons/GocashIconOffer';
// import useOutsideClick from '../../../../../../shared/hooks/useOutsideClick';

const OfferTag = ({cashbackText, offerText, offerData, actionHandler}) => {
  const [visible, setVisible] = useState(false);
  // const offerRef = useRef();

  // useOutsideClick(offerRef, () => {
  //   setVisible(false);
  // });

  useEffect(() => {
    if (visible && !offerData) {
      actionHandler();
    }
  }, [visible]);

  return (
    <S.HoverTargetWrapperDiv
      // ref={offerRef}
      onMouseEnter={() => {
        if (!visible) setVisible(true);
      }}
      onMouseLeave={() => {
        if (visible) setVisible(false);
      }}
    >
      <S.OfferOuterWrap>
        <GocashOfferIcon />
        <S.OfferInfoText
          onClick={e => {
            e.stopPropagation();
            setVisible(true);
          }}
        >
          {cashbackText} {offerText}
        </S.OfferInfoText>
      </S.OfferOuterWrap>
      {(visible && (
        <S.HiddenDropdownWrapperDiv>
          {(offerData &&
            offerData.data &&
            offerData.data.map(item => (
              <S.TopDiv>
                <S.OfferBlockConatiner>
                  <S.OfferBlockInnerContainer>
                    <S.OfferBlockWrap>
                      <GocashOfferIcon />
                    </S.OfferBlockWrap>
                    <S.OfferBlockWrap>
                      <S.OfferBlocklabel>{item.pt || ''}</S.OfferBlocklabel>
                      {(item && item.pa === 1 && (
                        <S.PreAppliedWrap>PRE-APPLIED</S.PreAppliedWrap>
                      )) ||
                        null}
                      <S.OfferDescription>{item.st || ''}</S.OfferDescription>
                    </S.OfferBlockWrap>
                  </S.OfferBlockInnerContainer>
                </S.OfferBlockConatiner>
                <S.TipPositioning />
              </S.TopDiv>
            ))) ||
            null}
        </S.HiddenDropdownWrapperDiv>
      )) ||
        null}
    </S.HoverTargetWrapperDiv>
  );
};

export default OfferTag;
